"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriber = void 0;
var Subscriber = /** @class */ (function () {
    function Subscriber(callback) {
        this.version = 0;
        this.callback = callback;
    }
    Subscriber.prototype.notify = function () {
        if (this.callback) {
            this.callback();
        }
    };
    return Subscriber;
}());
exports.Subscriber = Subscriber;
//# sourceMappingURL=Subscriber.js.map